"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextStyles = exports.Grid = exports.Colors = void 0;
// This file is automatically generated. Do not edit or commit.
// Honeycomb style exports
// Note: This file is automatically generated by style-exporter.js
// Note: Do not commit or edit this file
var Colors = __importStar(require("./foundations/colors/styles"));
exports.Colors = Colors;
var Grid = __importStar(require("./foundations/grid/styles"));
exports.Grid = Grid;
__exportStar(require("./foundations/icons/styles"), exports);
__exportStar(require("./foundations/shadows/styles"), exports);
__exportStar(require("./foundations/spacing/styles"), exports);
var TextStyles = __importStar(require("./patterns/textstyles/styles"));
exports.TextStyles = TextStyles;
